import { render } from "./HeroiconsSolidDocument.vue?vue&type=template&id=33c30ed3"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDocument.vue"]])

export default __exports__